import { Component, signal, OnInit, inject, PLATFORM_ID } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';
import { ScrollToTopComponent } from './components/shared/scroll-to-top/scroll-to-top.component';
import { inject as injectVercel } from "@vercel/analytics";
import { isPlatformBrowser } from '@angular/common';
import { filter } from 'rxjs/operators';
import { SeoService } from './services/seo.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavbarComponent, ScrollToTopComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {
  protected readonly title = signal('vettroTraders-comingSoon');
  private platformId = inject(PLATFORM_ID);
  private router = inject(Router);
  private seoService = inject(SeoService);

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      injectVercel();
    }

    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.seoService.setCanonicalURL(event.urlAfterRedirects);
    });
  }
}
